// extracted by mini-css-extract-plugin
module.exports = {"spinnerContainer":"widget-space--spinnerContainer--2xo9H"};